module.exports = __webpack_public_path__ + "img/保定市第二医院.be68a386.png";